//@ts-ignore
//@ts-nocheck
import { createIcon } from "@chakra-ui/icon";
import { SmallCloseIcon } from "@chakra-ui/icons";
import { ButtonProps, Button } from "@chakra-ui/react";
import React from "react";
import icons from "./icons";

const Icon: React.FC<{ name: string; [key: string]: any }> = ({
  name,
  size,
  ...rest
}) => {
  if (name === "small-close") {
    return <SmallCloseIcon width={size} height={size} {...rest} />;
  }
  let value: any = icons[name];
  if (name === "check-circle") {
    value = icons["check-circular"];
  }
  const zz: any = {};
  if (size) {
    zz.boxSize = size;
  }
  if (value) {
    const CIcon = createIcon(value);
    return <CIcon {...zz} {...rest} />;
  }
  return null;
};

interface XButtonProps extends ButtonProps {
  leftIcon?: any;
  [key: string]: any;
}

export const XButton: React.FC<XButtonProps> = ({ leftIcon, ...rest }) => {
  let icon = typeof leftIcon === "string" ? <Icon name={leftIcon} /> : leftIcon;
  return <Button {...rest} leftIcon={icon} />;
};

export default Icon;
